import React from "react";
import { Skeleton } from "@mui/material";

import "./CSkeleton.css";

const CSkeleton = ({ lines = 1, variant = "text", className = "" }) => {
    return (
        <div className={`generic-block-skeleton ${className}`}>
            <div className="generic-block-skeleton-box">
                {Array.from({ length: lines }).map((_, index) => (
                    <Skeleton key={index} variant={variant} />
                ))}
            </div>
        </div>
    );
};

export default CSkeleton;